import React from 'react';
import { OptionValue } from '../../../services/types/Misc';
import FormRadio from './FormRadio';

interface Props {
  name: string;
  elements: OptionValue[];
}

const FormRadioGroup: React.FC<Props> = ({ name, elements }) => {
  const drawRadio = (option: OptionValue) => (
    <div key={option.id} className="basic-radio-btn">
      <FormRadio
        name={name}
        text={option.text}
        value={option.value || ''}
        disabled={option.disabled || false}
      />
    </div>
  );

  return (
    <div className="radio-group-horizontal">{elements.map((option) => drawRadio(option))}</div>
  );
};

export default FormRadioGroup;
